import React, { useState, useEffect } from 'react';

import { Container, QuestionsContainer, PageTitle, Table } from '../components/tables/Style'
import { AddButton, UpdateButton, DeleteButton } from '../components/tables/Buttons'
import { InputArea } from './Styles/Inputs';

import { getAllCollection, addToCollection, deleteFromCollection } from '../services/database';

import { withRouter } from 'react-router-dom';

const ShopProducts = ({ history }) => {
    //State
    const [rows, setRows] = useState([]);
    const [showAddRow, setShowAddRow] = useState(false);
    const [inputs, setInputs] = useState({
        title: '',
    });

    useEffect(() => {
        getAllCollection('shop_products').then(result => {
            if (result)
                setRows(result.data);
            else console.log('No data returned')
        })
    }, []);

    //Functions
    const handleAddButton = () => {
        setShowAddRow(true);
    }

    const handleSaveButton = () => {
        if (inputs.title) {
            setShowAddRow(false);
            addToCollection(
                'shop_products',
                (rows.length > 0 ? Math.max.apply(Math, rows.map(function (o) { return o.id; })) + 1 : 0).toString(),
                {
                    id: rows.length > 0 ? Math.max.apply(Math, rows.map(function (o) { return o.id; })) + 1 : 0,
                    title: inputs.title
                }
            );
            getAllCollection('shop_products').then(result => {
                setRows(result.data);
            })
            setInputs({
                title: ''
            });
        }
    }

    const handleDelete = (id) => {
        deleteFromCollection('shop_products', id);
        getAllCollection('shop_products').then(result => {
            setRows(result.data);
        })
    }

    const handleUpdate = (id) => {
        history.push('/edit-shop-products', {
            id: id
        });
    }

    return (
        <Container>
            <PageTitle>Seminari</PageTitle>
            <QuestionsContainer>
                <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                    <AddButton onClick={() => handleAddButton()}>
                        <i className="fas fa-plus-circle"></i>
                        <h1>Dodaj</h1>
                    </AddButton>
                </div>
                <Table>
                    <tr>
                        <th style={{ width: '2%' }}>ID</th>
                        <th style={{ width: '80%' }}>Naslov</th>
                        <th style={{ width: '18%' }} />
                    </tr>
                    <tr style={{ backgroundColor: '#222831', display: showAddRow ? 'revert' : 'none' }}>
                        <td>{rows.length > 0 ? Math.max.apply(Math, rows.map(function (o) { return o.id; })) + 1 : 0}</td>
                        <td>
                            <InputArea
                                rows={8}
                                onChange={(e) => setInputs({ ...inputs, title: e.target.value })}
                                value={inputs.title}
                            />
                        </td>
                        <td>
                            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                <AddButton onClick={() => handleSaveButton()}>
                                    <h1>Potvrdi</h1>
                                </AddButton>
                            </div>
                        </td>
                    </tr>
                    {rows.length > 0 ? rows.map(row =>
                        <tr key={'row_id_' + row.id}>
                            <td>{row.id}</td>
                            <td>{row.title}</td>
                            <td>
                                <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                    <UpdateButton onClick={() => handleUpdate(row.id)}>
                                        <i className="fas fa-edit"></i>
                                    </UpdateButton>
                                    <DeleteButton onClick={() => handleDelete(row.id)}>
                                        <i className="fas fa-trash-alt"></i>
                                    </DeleteButton>
                                </div>
                            </td>
                        </tr>
                    )
                        : false
                    }
                </Table>
            </QuestionsContainer>
        </Container>
    )
}

export default withRouter(ShopProducts);